<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 订单管理
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- 搜索栏 -->
          <div class="toolbar">
            <el-input v-model="query.orderNo" placeholder="订单号" clearable style="width: 180px; margin-right: 10px;" @keyup.enter="handleSearch"></el-input>
            <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 130px; margin-right: 10px;" @change="handleSearch">
              <el-option label="待支付" :value="0"></el-option>
              <el-option label="已支付" :value="1"></el-option>
              <el-option label="已发货" :value="2"></el-option>
              <el-option label="已完成" :value="3"></el-option>
              <el-option label="已取消" :value="4"></el-option>
              <el-option label="已退款" :value="5"></el-option>
              <el-option label="部分退款" :value="6"></el-option>
              <el-option label="全额退款" :value="7"></el-option>
            </el-select>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="margin-right: 10px;"
              @change="handleSearch"
            ></el-date-picker>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </div>

          <!-- 订单表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="订单号" prop="orderNo" width="180"></el-table-column>
              <el-table-column align="center" label="会员" width="120">
                <template #default="{ row }">
                  <div>{{ row.memberName || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">{{ row.memberPhone }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="会员角色" prop="memberRoleName" width="100">
                <template #default="{ row }">
                  <el-tag :type="roleTagType(row.memberRole)" size="small">{{ row.memberRoleName || '-' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单金额" prop="totalAmount" width="110">
                <template #default="{ row }">
                  <span style="color: #e6a23c; font-weight: bold;">¥{{ formatPrice(row.totalAmount) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="余额支付" prop="balanceAmount" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.balanceAmount) }}</template>
              </el-table-column>
              <el-table-column align="center" label="微信支付" prop="wxPayAmount" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.wxPayAmount) }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="statusName" width="90">
                <template #default="{ row }">
                  <el-tag :type="statusTagType(row.status)" size="small">{{ row.statusName }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="支付时间" width="160">
                <template #default="{ row }">{{ formatTime(row.payTime) }}</template>
              </el-table-column>
              <el-table-column align="center" label="下单时间" width="160">
                <template #default="{ row }">{{ formatTime(row.createTime) }}</template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="180">
                <template #default="{ row }">
                  <span class="editor" @click="viewDetail(row)">详情</span>
                  <span v-if="canRefund(row)" class="editor" style="margin-left: 12px; color: #f56c6c;"
                    @click="openRefundDialog(row)">退款</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" v-model="detailVisible" width="700px" center>
      <div v-if="detailData" v-loading="detailLoading">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ detailData.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="statusTagType(detailData.status)" size="small">{{ detailData.statusName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="会员">{{ detailData.memberName || '-' }} ({{ detailData.memberPhone }})</el-descriptions-item>
          <el-descriptions-item label="会员角色">{{ detailData.memberRoleName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">¥{{ formatPrice(detailData.totalAmount) }}</el-descriptions-item>
          <el-descriptions-item label="余额支付">¥{{ formatPrice(detailData.balanceAmount) }}</el-descriptions-item>
          <el-descriptions-item label="微信支付">¥{{ formatPrice(detailData.wxPayAmount) }}</el-descriptions-item>
          <el-descriptions-item label="微信交易号">{{ detailData.wxTransactionId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ formatTime(detailData.payTime) }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ formatTime(detailData.createTime) }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 订单商品列表 -->
        <h4 style="margin: 16px 0 8px; color: #333;">商品明细</h4>
        <el-table :data="detailData.items || []" :header-cell-style="{ background: '#f7f7f7', color: '#333' }" size="small">
          <el-table-column align="center" label="商品" min-width="180">
            <template #default="{ row }">
              <div style="display: flex; align-items: center;">
                <img v-if="row.productImage" :src="resolveImg(row.productImage)" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 8px;" />
                <span>{{ row.productName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="单价" width="100">
            <template #default="{ row }">¥{{ formatPrice(row.price) }}</template>
          </el-table-column>
          <el-table-column align="center" label="数量" prop="quantity" width="80"></el-table-column>
          <el-table-column align="center" label="小计" width="100">
            <template #default="{ row }">¥{{ formatPrice(row.subtotal) }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 退款弹窗 -->
    <el-dialog title="发起退款" v-model="refundVisible" width="540px" center>
      <el-form label-width="100px" size="small">
        <el-form-item label="订单号">{{ refundForm.orderNo }}</el-form-item>
        <el-form-item label="订单金额">¥{{ refundForm.totalAmount.toFixed(2) }}（余额 ¥{{ refundForm.balanceAmount.toFixed(2) }} / 微信 ¥{{ refundForm.wxPayAmount.toFixed(2) }}）</el-form-item>
        <el-form-item label="已退金额">¥{{ refundForm.refundedAmount.toFixed(2) }}</el-form-item>
        <el-form-item label="本次退款">
          <el-input-number v-model="refundForm.refundAmount" :min="0.01" :max="refundForm.totalAmount - refundForm.refundedAmount" :precision="2" :step="0.01" style="width: 200px"></el-input-number>
          <span style="margin-left: 12px; color: #909399; font-size: 12px;">剩余可退 ¥{{ (refundForm.totalAmount - refundForm.refundedAmount).toFixed(2) }}</span>
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input v-model="refundForm.reason" type="textarea" :rows="2" maxlength="200" placeholder="请说明退款原因"></el-input>
        </el-form-item>
        <div style="background:#fdf6ec;padding:8px 12px;border-radius:4px;color:#e6a23c;font-size:12px;line-height:1.6">
          退款将按支付通道占比拆分（balance:wx），余额立即返还，微信走商户证书发起退款；同时按比例回收已分配佣金。
        </div>
      </el-form>
      <template #footer>
        <el-button @click="refundVisible = false">取消</el-button>
        <el-button type="primary" :loading="refundLoading" @click="submitRefund">确认退款</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: null,
      query: {
        pageNum: 1,
        pageSize: 10,
        status: null,
        orderNo: '',
      },
      detailVisible: false,
      detailLoading: false,
      detailData: null,
      refundVisible: false,
      refundLoading: false,
      refundForm: {
        orderId: null,
        orderNo: '',
        totalAmount: 0,
        refundedAmount: 0,
        refundAmount: 0,
        reason: '',
        balanceAmount: 0,
        wxPayAmount: 0,
      },
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    resolveImg(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url
      return (this.globalImgPath || '') + url
    },
    formatTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      return new Date(val).toLocaleString('zh-CN', { hour12: false })
    },
    roleTagType(role) {
      const map = { 1: 'danger', 2: 'warning', 3: '', 4: 'info' }
      return map[role] || 'info'
    },
    statusTagType(status) {
      const map = { 0: 'info', 1: 'success', 2: '', 3: 'success', 4: 'info', 5: 'danger', 6: 'warning', 7: 'danger' }
      return map[status] || 'info'
    },
    canRefund(row) {
      // 仅已支付/已发货/已完成/部分退款可继续退款
      return [1, 2, 3, 6].includes(Number(row.status))
    },
    openRefundDialog(row) {
      this.refundForm = {
        orderId: row.id,
        orderNo: row.orderNo,
        totalAmount: Number(row.totalAmount || 0),
        refundedAmount: Number(row.refundAmount || 0),
        refundAmount: Math.max(0, Number(row.totalAmount || 0) - Number(row.refundAmount || 0)),
        reason: '',
        balanceAmount: Number(row.balanceAmount || 0),
        wxPayAmount: Number(row.wxPayAmount || 0),
      }
      this.refundVisible = true
    },
    async submitRefund() {
      if (!this.refundForm.refundAmount || this.refundForm.refundAmount <= 0) {
        this.$message.warning('退款金额必须大于 0')
        return
      }
      const remain = this.refundForm.totalAmount - this.refundForm.refundedAmount
      if (this.refundForm.refundAmount > remain + 0.001) {
        this.$message.warning(`退款金额不能超过剩余可退 ¥${remain.toFixed(2)}`)
        return
      }
      this.refundLoading = true
      try {
        const res = await axiosconf.applicationJson('/mall/admin/refund/apply', {
          orderId: this.refundForm.orderId,
          refundAmount: this.refundForm.refundAmount,
          reason: this.refundForm.reason,
        })
        if (res.data && res.data.code === 0) {
          this.$message.success('退款已受理')
          this.refundVisible = false
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '退款失败')
        }
      } catch (e) {
        this.$message.error('退款请求异常')
      } finally {
        this.refundLoading = false
      }
    },
    handleSearch() {
      this.query.pageNum = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize,
        }
        if (this.query.status !== null && this.query.status !== '') params.status = this.query.status
        if (this.query.orderNo) params.orderNo = this.query.orderNo
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0]
          params.endDate = this.dateRange[1]
        }

        const res = await axiosconf.applicationJson('/mall/admin/order/list', params)
        if (res.data && res.data.code === 0) {
          const data = res.data.data
          this.tableData = data.records || []
          this.total = data.total || 0
        }
      } catch (e) {
        console.error('获取订单列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.query.pageNum = page
      this.fetchList()
    },
    async viewDetail(row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detailData = null
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/order/detail/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.detailData = res.data.data
        }
      } catch (e) {
        this.$message.error('获取订单详情失败')
      } finally {
        this.detailLoading = false
      }
    },
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.editor {
  color: #679FF6;
  cursor: pointer;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
